import { FacilityTab } from "../../../contexts";
import { DrawdownBatch } from "../../../contexts";
import { LoanApplicationCaseStatus } from "../../../hooks/api/types";

export const FACILITY_TABS = [
  { id: FacilityTab.OVERVIEW, label: "Overview" },
  { id: FacilityTab.VENDORS, label: "Vendors" },
  // { id: FacilityTab.DOCUMENTS, label: "Documents" },
  // { id: FacilityTab.SETTINGS, label: "Settings" },
  //todo
];

export enum InvoiceGroups {
  ACTION_REQUIRED = "Action Required",
  IN_REVIEW = "In Review",
  APPROVED = "Approved",
  CLOSED = "Closed",
  REJECTED = "Rejected",
}

export type InvoiceListingProps = {
  loanApplicationId: string;
  isPayablesFacility?: boolean;
  initialDrawdowns: DrawdownBatch[];
};

export const IBAN_TEXT = "AE430351411325902818004";

export const IN_REVIEW_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.IN_REVIEW_LOAN_OPS,
  LoanApplicationCaseStatus.IN_REVIEW_MLRO,
  LoanApplicationCaseStatus.IN_REVIEW_UW,
  LoanApplicationCaseStatus.IN_REVIEW_SUW,
  LoanApplicationCaseStatus.IN_REVIEW_CRO,
  LoanApplicationCaseStatus.IN_REVIEW_RM,
];

export const PAST_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.PAST_DUE,
  LoanApplicationCaseStatus.PAST_MATURITY,
];

const PAST_AND_PAUSED_STATUSES: LoanApplicationCaseStatus[] = [
  ...PAST_STATUSES,
  LoanApplicationCaseStatus.PAUSED,
];

export const ACTIVE_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.ACTIVE,
  LoanApplicationCaseStatus.RESTRUCTURED,
  ...PAST_AND_PAUSED_STATUSES,
  LoanApplicationCaseStatus.OVERPAID,
];

export const DRAWDOWN_ELIGIBLE_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.ACTIVE,
  ...PAST_STATUSES,
  LoanApplicationCaseStatus.OVERPAID,
];

export const LATE_FEE_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.PAST_MATURITY,
];

export const POST_ACTIVE_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.ACTIVE,
  ...PAST_AND_PAUSED_STATUSES,
  LoanApplicationCaseStatus.EXPIRED,
  LoanApplicationCaseStatus.OVERPAID,
];

export const PROGRESS_BAR_STATUSES: LoanApplicationCaseStatus[] = [
  ...PAST_AND_PAUSED_STATUSES,
  LoanApplicationCaseStatus.ACTIVE,
];

export const INTEREST_RATE_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.OFFER_SENT,
  LoanApplicationCaseStatus.OFFER_REJECTED,
  LoanApplicationCaseStatus.CONTRACT_PENDING_SIGNATURE,
  LoanApplicationCaseStatus.CONTRACT_SIGNED,
  LoanApplicationCaseStatus.OFFER_ACCEPTED,
  LoanApplicationCaseStatus.ACTIVE,
  LoanApplicationCaseStatus.WAITING_FOR_DISBURSEMENT,
  ...PAST_AND_PAUSED_STATUSES,
];

export const REQUESTED_STATUSES: LoanApplicationCaseStatus[] = [
  ...IN_REVIEW_STATUSES,
  LoanApplicationCaseStatus.ADDITIONAL_INFO_REQUIRED,
  LoanApplicationCaseStatus.APPROVED_SUW,
  LoanApplicationCaseStatus.APPROVED_CRO,
  LoanApplicationCaseStatus.WITHDRAWN,
  LoanApplicationCaseStatus.ON_HOLD,
  LoanApplicationCaseStatus.DECLINED_MLRO,
  LoanApplicationCaseStatus.DECLINED_LOAN_OPS,
  LoanApplicationCaseStatus.DECLINED_SUW,
  LoanApplicationCaseStatus.DECLINED_CRO,
  LoanApplicationCaseStatus.SEND_TO_SERVICING,
  LoanApplicationCaseStatus.WAITING_FOR_DISBURSEMENT,
];

export const PROPOSED_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.GENERATE_OFFER,
  LoanApplicationCaseStatus.OFFER_SENT,
  LoanApplicationCaseStatus.OFFER_REJECTED,
  LoanApplicationCaseStatus.DECLINED_SME,
];

export const APPROVED_STATUSES: LoanApplicationCaseStatus[] = [
  LoanApplicationCaseStatus.OFFER_ACCEPTED,
  LoanApplicationCaseStatus.CONTRACT_SENT,
  LoanApplicationCaseStatus.CONTRACT_PENDING_SIGNATURE,
  LoanApplicationCaseStatus.CONTRACT_SIGNED,
  LoanApplicationCaseStatus.EARLY_CLOSURE,
  LoanApplicationCaseStatus.FORCED_CLOSURE,
  LoanApplicationCaseStatus.CLOSED_OBLIGATIONS_MET,
  LoanApplicationCaseStatus.CLOSED_WRITTEN_OFF,
  LoanApplicationCaseStatus.CLOSED_RESCHEDULED,
  LoanApplicationCaseStatus.EXPIRED,
];

export enum InvoiceEntryMode {
  MANUAL = "manual",
  BULK = "bulk",
}

export enum BulkParseStatus {
  IDLE = "idle",
  EXTRACTING = "extracting",
  ERRORS = "errors",
  SUCCESS = "success",
}

export const DEFAULT_CURRENCY = "AED";
